module.exports = __webpack_public_path__ + "assets-cabinet/img/person-icon.1595a115.svg";